import React from 'react';
import { Helmet } from '@ies/ace';
import { publicPath } from '@/utils';
/** todo 部分引入组件 */

import './index.less';

const Layout = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
  rel: "shortcut icon",
  href: publicPath('/favicon.ico'),
  type: "image/x-icon"
})), children);

export default Layout;